import { usePlatformUpdate } from '@reapitform/hooks'

export const useDefaultEmergencyContactDelete = (id: string) => {
  const path: string = `/api/Organization/DefaultRepairer/${id}`

  const [deleteEmergencyContact, isLoading, returnData, isSuccess, isError] = usePlatformUpdate<undefined, any>({
    path: path,
    method: 'DELETE',
    headers: {},
    errorMessage: 'Failed to delete the repairer',
    successMessage: 'Repairer successfully deleted',
  })

  return { deleteEmergencyContact, returnData, isLoading, isSuccess, isError }
}
